import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { CUSTOM_CONTEXTUAL_REPORT_ID } from './customContextualReportId';

const customColumns = {
    [REPORT_PRESET.DEFAULT]: [
        FIELDS.SEGMENT_NAME.field,
        FIELDS.ACCOUNT_DESCRIPTION.field,
        FIELDS.AUDIENCE_CAMPAIGN_USING.field,
        FIELDS.LAST_MODIFY_BY.field,
        FIELDS.LAST_MODIFY_ON.field,
        FIELDS.CREATE_TIME.field,
    ].map(field => generateColumnId(CUSTOM_CONTEXTUAL_REPORT_ID, field)),
};

// columns used by the 'All' column view
const defaultColumns = [
    FIELDS.SEGMENT_NAME.field,
    FIELDS.ACCOUNT_DESCRIPTION.field,
    FIELDS.AUDIENCE_CAMPAIGN_USING.field,
    FIELDS.LAST_MODIFY_BY.field,
    FIELDS.LAST_MODIFY_ON.field,
    FIELDS.CREATE_TIME.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(CUSTOM_CONTEXTUAL_REPORT_ID, field));

export { customColumns, defaultColumns };
